import { useHandleAction } from "@utils/hook/index.hook";
import { useSelectionStore } from "@utils/states/index.state";

const ColumnList = () => {
  const { handleAction } = useHandleAction({});
  const { clearSelection } = useSelectionStore();

  return [
    {
      name: "ID",
      cell: (row: any) => (
        <span className="font-semibold text-gray-700">{row.id}</span>
      ),
      sortable: true,
    },
    {
      name: "Name",
      cell: (row: any) => row.name,
      sortable: false,
    },
    {
      name: "Actions",
      cell: (row: any) => (
        <div className="flex items-center gap-3 text-blue-600 cursor-pointer">
          <button
            className="cursor-pointer text-[#1DA077]"
            onClick={() => handleAction({ type: "modal-edit", data: row.id })}
          >
            Edit
          </button>
          <button
            className="text-[#C33241] cursor-pointer"
            onClick={() => {
              clearSelection();
              handleAction({
                type: "confirm",
                data: { type: "delete", id: row.id },
              });
            }}
            title="Delete"
          >
            Delete
          </button>
        </div>
      ),
      sortable: false,
    },
  ];
};

const DiscountColumnList = () => {
  const { handleAction } = useHandleAction({});
  const { clearSelection } = useSelectionStore();

  return [
    {
      name: "ID",
      cell: (row: any) => (
        <span className="font-semibold text-gray-700">{row.id}</span>
      ),
      sortable: true,
    },
    {
      name: "Name",
      cell: (row: any) => row.name,
      sortable: false,
    },
    {
      name: "Discount Type",
      cell: (row: any) => row.discount_type,
      sortable: false,
    },
    {
      name: "Discount Limit",
      cell: (row: any) => row.limit,
      sortable: false,
    },
    {
      name: "Discount Amount",
      cell: (row: any) => row.value,
      sortable: false,
    },
    {
      name: "Discount Coupon",
      cell: (row: any) => row.discount_coupon,
      sortable: false,
    },
    {
      name: "Actions",
      cell: (row: any) => (
        <div className="flex items-center gap-3 text-blue-600 cursor-pointer">
          <button
            className="cursor-pointer text-[#1DA077]"
            onClick={() => handleAction({ type: "modal-edit", data: row.id })}
          >
            Edit
          </button>
          <button
            className="text-[#C33241] cursor-pointer"
            onClick={() => {
              clearSelection();
              handleAction({
                type: "confirm",
                data: { type: "delete", id: row.id },
              });
            }}
            title="Delete"
          >
            Delete
          </button>
        </div>
      ),
      sortable: false,
    },
  ];
};

export { ColumnList, DiscountColumnList };
